<div [hidden]="!show">
  <!-- ['blur', 'brightness', 'contrast', 'grayscale', 'hue-rotate', 'invert', 'opacity', 'saturate', 'sepia'] -->
  <app-css-filters [target]="true" [filters]="['brightness', 'contrast', 'hue-rotate', 'invert', 'saturate', 'grayscale']">
  </app-css-filters>
</div>
